export { useRouting as default } from 'expo-navigation-core'
